<template>
  <div class="nav-breadcrumbs">
    <template v-for="(crumb, index) in crumbs">
      <template v-if="crumbs[index+1]">
        <v-btn flat small color="primary" @click="onSelect(crumb)">{{crumb.name}}</v-btn>
        <v-icon size="18">keyboard_arrow_right</v-icon>
      </template>
    </template>
    <v-btn outline round flat color="primary" :title="triggerTooltip" class="overlay-trigger nav-breadcrumbs--btn"
           @mousedown.stop.prevent="toggleBrowser" @click.prevent>
      {{crumbs.length > 0 ? crumbs[crumbs.length - 1].name : blankLabel}}
      <v-icon>{{`keyboard_arrow_${showBrowser? 'up':'down'}`}}</v-icon>
    </v-btn>
  </div>
</template>

<script>
  import { eventBus } from '@/utils'

  export default {
    props: {
      onSelect: {
        type: Function,
        required: true
      },

      blankLabel: {
        type: String,
        required: true
      },

      triggerTooltip: {
        type: String,
        default: ''
      },

      hideBrowserEventName: {
        type: String,
        required: true
      },

      toggleBrowserEventName: {
        type: String,
        required: true
      },

      crumbs: {
        type: Array,
        required: true
      }
    },

    mounted: function () {
      eventBus('geo').$on(this.hideBrowserEventName, () => {
        this.showBrowser = false
      })
    },

    data: function () {
      return {
        showBrowser: false
      }
    },

    methods: {
      toggleBrowser () {
        this.showBrowser = !this.showBrowser
        const overlayTrigger = this.$el.querySelector('.overlay-trigger')
        eventBus('geo').$emit(this.toggleBrowserEventName, overlayTrigger.getBoundingClientRect().bottom)
      },

      href (slug) {
        return this.hrefFn(slug)
      }
    }
  }
</script>

<style lang="stylus">
  .nav-breadcrumbs
    .v-btn
      min-width: 0
      margin: 0

  .nav-breadcrumbs--btn
    border-radius: 5px;
</style>



// WEBPACK FOOTER //
// frontend/src/pages/Geo/components/NavBreadcrumbs.vue